module.exports = __webpack_public_path__ + "static/media/ticket_campaign_preview_details_title_pic.da72bf7d.svg";